import React from 'react';
import ErrorImage from '../Assets/Images/404.png'


function ErrorPage() { 
   return ( 
    <div className='h-100 d-flex align-items-center justify-content-center'>
       <img className='image-fluid' src={ErrorImage}/>
    </div>
    );


}

export default ErrorPage; 